/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryUser } from '../../models/inventory-user';

export interface ChangeInventoryUserRole$Params {
  id: string;
  roleId: number;
}

export function changeInventoryUserRole(http: HttpClient, rootUrl: string, params: ChangeInventoryUserRole$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryUser>> {
  const rb = new RequestBuilder(rootUrl, changeInventoryUserRole.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('roleId', params.roleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryUser>;
    })
  );
}

changeInventoryUserRole.PATH = '/admin/inventories/user/{id}/change';
